<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-analytics-transcript-search-results">

    <wy-page-modal ref="pageModal" :onOpen="handlePageModalOpen" :onClose="handlePageModalClose" :closeOnClick="true">
      <wy-analytics-transcript-search-expand :parent="module" :transcript="selectedItem" :from="from"
        :transcriptSummaryOpened="selectedItem && selectedItem.isOpened" :transcriptSummaryNetworkError="selectedItem && selectedItem.isError"
        @handle-transcript-summary="handleViewTranscriptSummary" :iconType="controller && controller.transcriptIconType"/>
    </wy-page-modal>

    <div class="search-result-content">
      <div class="div-transcripts-viewer-header">
        <!-- <div class="div-transcript-page-infor">Showing {{pageItemStart}}-{{pageItemEnd}} <span v-if="totalConversations>0"> within {{totalConversations}} conversations</span></div> -->
        <div class="div-transcript-page-infor">
          <!-- <span v-if="totalMatchedConversations == 1 || totalMatchedConversations == 0">Found {{totalMatchedConversations}} transcripts</span> 
          <span v-else-if="totalMatchedConversations">Found {{totalMatchedConversations}} transcripts</span>  -->
          <div v-if="(totalMatchedConversations == 0)" class="div-transcript-page-infor">Found {{(totalMatchedConversations * ($store.getters.xnumber ? $store.getters.xnumber : 1)).toLocaleString('en-US')}} results.</div>
          
          <div v-else-if="(totalMatchedConversations * ($store.getters.xnumber ? $store.getters.xnumber : 1)) < pageNo * pageSize" class="div-transcript-page-infor">Found {{(totalMatchedConversations * ($store.getters.xnumber ? $store.getters.xnumber : 1)).toLocaleString('en-US')}} results of {{(totalConversations * ($store.getters.xnumber ? $store.getters.xnumber : 1)).toLocaleString('en-US')}} conversations. Showing {{(pageNo - 1) * pageSize + 1}} - {{(totalMatchedConversations * ($store.getters.xnumber ? $store.getters.xnumber : 1)).toLocaleString('en-US')}}</div>
          
          <div v-else class="div-transcript-page-infor">Found {{(totalMatchedConversations * ($store.getters.xnumber ? $store.getters.xnumber : 1)).toLocaleString('en-US')}} results of {{(totalConversations * ($store.getters.xnumber ? $store.getters.xnumber : 1)).toLocaleString('en-US')}} conversations. Showing {{(pageNo - 1) * pageSize + 1}} - {{pageNo * pageSize}}</div>
        </div>
        <div class="sort-by-text-container">
          Sort by
          <el-select v-model="sortBy" collapse-tags :disabled="totalMatchedConversations < 2" size="mini"
            style="margin-left: 5px;" prev-text="<" next-text=">" popper-class="transcript-filter-dropdown"
            @visible-change="handleVisibleChangeSortBy"
            @change="handleSortBy" placeholder="Sort by"
            :class="(isShortLengthSortName ? 'short-name-transcript-filter' : 'transcript-filter')">
            <el-option v-for="(item) in sortByList" :key="item.key" :label="item.label" :value="item.key">
            </el-option>
          </el-select>
        </div>

        <div class="div-transcript-pagination">
          <el-pagination :page-size="pageSize" :page-count="pageCount" @prev-click="handlePrev" @next-click="handleNext"
            :current-page="pageNo" @current-change="pageChanged" layout="prev, next">
          </el-pagination>
        </div>
      </div>

      <div v-if="transcriptList && transcriptList.length > 0" class="div-transcripts-viewer-content">
        <div class="div-transcript-details" v-for="(transcript, index) in transcriptList" :key="index">
          <wy-analytics-transcript-search-details :parent="module" :transcript="transcript"
            :transcriptClickEvent="handleTranscriptClick" :transcriptSummaryOpened="transcript.isOpened" 
            :transcriptSummaryNetworkError="transcript.isError" @handle-transcript-summary="handleViewTranscriptSummary" :from="from" :iconType="controller && controller.transcriptIconType" 
          />
        </div>
      </div>
      <div
        v-else-if="!controller.loading && transcriptSearchFiltersComponent && transcriptSearchFiltersComponent.isSavedTranscriptResultSelected && transcriptSearchFiltersComponent.appliedFilterCount == 0 && !dataModel.appliedFiltersCounter && !transcriptSearchFiltersComponent.appliedSearchKeyword"
        class="no-saved-content">
        <div class="no-data"></div>
        <div class="no-data-content">
          <div class="no-data-title">Sorry! You don't have any transcripts saved.</div>
          <div class="no-data-subtitle">To save a transcript, click the star icon in the top right corner of a transcript.
          </div>
        </div>
      </div>
      <div
        v-else-if="!controller.loading && transcriptSearchFiltersComponent && transcriptSearchFiltersComponent.isSavedTranscriptResultSelected && (transcriptSearchFiltersComponent.appliedFilterCount > 0 || dataModel.appliedFiltersCounter > 0 || transcriptSearchFiltersComponent.appliedSearchKeyword)"
        class="no-saved-content">
        <div class="no-data"></div>
        <div class="no-data-title">Sorry! No saved transcript available in this search.</div>
        <div class="no-data-subtitle">Try adjusting your filters to locate saved transcripts.</div>
      </div>
      <div v-else-if="!controller.loading" class="no-topic-content">
        <div class="no-transcript-found"></div>
        <div class="no-data-title">No transcripts found</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapActions } from "vuex";
import WyTranscriptSearchDetails from "./wy-analytics-transcript-search-details.vue";
import WyTranscriptSearchExpand from './wy-analytics-transcript-search-expand.vue';
import WyPageModal from '../widgets/wy-page-modal'

export default Vue.extend({
  name: "wy-analytics-transcript-search-results",
  props: ['controller', 'contactReason', 'from'],
  components: {
    'wy-analytics-transcript-search-details': WyTranscriptSearchDetails,
    'wy-analytics-transcript-search-expand': WyTranscriptSearchExpand,
    'wy-page-modal': WyPageModal,
  },

  data() {
    return {
      module: this,
      transcriptSearchFiltersComponent: {},
      contactReasonKeywords: '',
      transcriptNumStart: 1,
      transcriptNumEnd: 3,
      transcriptList: null,
      transcriptSummaryOpened: false,
      isShortLengthSortName: true,

      sortByList: [
        {
          key: 'newToOld',
          label: 'New to Old'
        },
        {
          key: 'oldToNew',
          label: 'Old to New'
        },
        {
          key: 'longestHandlingTime',
          label: 'Longest total handling time'
        },
        {
          key: 'shortestHandlingTime',
          label: 'Shortest total handling time'
        }
      ],
      sortBy: null,

      pageNo: 1,
      pageSize: 3,
      pageCount: 1,
      pageItemStart: 0,
      pageItemEnd: 0,

      totalConversations: 0,
      totalMatchedConversations: 0,

      initDate: null,
      selectedItem: null,

      savedTranscriptWithoutFilters: false,
      transcriptExpanded: false,
    };
  },

  computed: {
    ...mapGetters(["dataModel", "isHideResponse", "custTypesChanged"]),

    isMetricAnalysisPanel() {
      return this.from == 'metricAnalysis';
    }
  },

  methods: {
    ...mapActions(["fetchTranscriptSearch", "fetchTopicDisplayNameList", "fetchTopicResponseNameList", "fetchRelatedTopicList", "fetchIntentNames", "fetchMetricTranscriptSearch", "addTranscript", "removeTranscript", 'exportTranscriptSearch']),

    handleSortBy(value) {
      this.sortBy = value;
      this.transcriptSearchFiltersComponent.transcriptFilters['action'] = 'search';
      if (value == 'newToOld' || value == 'oldToNew') {
        this.isShortLengthSortName = true;
      } else {
        this.isShortLengthSortName = false;
      }

      this.isMetricAnalysisPanel ? this.loadMetricTopicConversations(1, {}, "Sort Results") : this.loadTopicConversations(1, false, "Sort Results");
    },

    handleVisibleChangeSortBy() {
      if (this.isMetricAnalysisPanel) return;
      
      if(this.controller.$refs.transcriptSearchFilters.$refs.allFilters) {
        this.controller.$refs.transcriptSearchFilters.$refs.allFilters.showPopper = false;
      }
      if(this.controller.$refs.transcriptSearchFilters.$refs.localAgentFilter) {
        this.controller.$refs.transcriptSearchFilters.$refs.localAgentFilter.showPopper = false;
      }
    },

    async addSavedTranscript(e, transcript) {
      e.stopPropagation();

      if (this.controller && this.controller.hideTranscriptPopover) {
        this.controller.hideTranscriptPopover();
      }

      let result = await this.addTranscript({ conversationId: transcript.conversationId });
      if (result && result.status && result.status == 200) {
        transcript.isSavedTranscript = true;
        // If in transcript-expand, refresh data
        if (this.controller.$refs.transcriptSearchFilters && this.transcriptExpanded) {
          this.controller.$refs.transcriptSearchFilters.applySearch();
        }
      }
    },
    handleNext() {
      this.transcriptNumStart = this.transcriptNumStart + this.pageSize;
      this.transcriptNumEnd = this.pageSize * (this.pageNo + 1);
    },
    handlePrev() {
      this.transcriptNumStart = this.transcriptNumStart - this.pageSize;
      this.transcriptNumEnd = this.transcriptNumEnd - this.pageSize;
    },
    async removeSavedTranscript(e, transcript) {
      e.stopPropagation();

      if (this.controller && this.controller.hideTranscriptPopover) {
        this.controller.hideTranscriptPopover();
      }

      let result = await this.removeTranscript({ conversationId: transcript.conversationId });
      if (result && result.status && result.status == 200) {
        transcript.isSavedTranscript = false;
        // if "View saved transcripts" filter is toggled on
        if (this.controller.$refs.transcriptSearchFilters && this.controller.$refs.transcriptSearchFilters.savedTranscriptResult) {
          this.controller.$refs.transcriptSearchFilters.applySearch();
        }
        // if "View saved transcripts" filter is toggled on for metric analysis
        if (this.controller && (this.controller.savedTranscriptResultBes || this.controller.savedTranscriptResultBas)) {
          await this.controller.loadTranscriptData();
        }
      }
    },

    async applyExport() {
      this.controller.loading = true;
      this.transcriptSearchFiltersComponent.transcriptFilters['action'] = 'export';
      
      const mergedTopics = this.controller.parent && this.controller.parent.currentItem && this.controller.parent.currentItem.mergedTopics || []
      await this.exportTranscriptSearch({ 
        from: 'transcripts', 
        topics: mergedTopics,
        pageNo: this.pageNo, 
        pageSize: this.pageSize + 1, 
        sortBy: this.sortBy, 
        transcriptSearchFilter: this.transcriptSearchFiltersComponent.transcriptFilters 
      })
      this.controller.loading = false;
    },

    pageChanged(pageNo) {
      if (this.isMetricAnalysisPanel) {
        this.loadMetricTopicConversations(pageNo, { action: 'search' }, "Page Scroll")
      } else {
        this.transcriptSearchFiltersComponent.transcriptFilters['action'] = 'search';
        this.loadTopicConversations(pageNo, true, "Page Scroll");
      }
    },

    prepareTimeRange(timeRangeResult) {
      this.sortBy = 'newToOld';
      if(timeRangeResult.data.totalConversations != undefined && timeRangeResult.data.totalConversations != null) {
        this.totalConversations = timeRangeResult.data.totalConversations;
      }

      // will remove max value
      timeRangeResult.data.maxResponseTime = timeRangeResult.data.maxResponseTime > 359999 ? 359999 : timeRangeResult.data.maxResponseTime;
      timeRangeResult.data.maxHandlingTime = timeRangeResult.data.maxHandlingTime > 359999 ? 359999 : timeRangeResult.data.maxHandlingTime;
      timeRangeResult.data.maxAgentHandlingTime = timeRangeResult.data.maxAgentHandlingTime > 359999 ? 359999 : timeRangeResult.data.maxAgentHandlingTime
      timeRangeResult.data.maxAgentResponseTime = timeRangeResult.data.maxAgentResponseTime > 359999 ? 359999 : timeRangeResult.data.maxAgentResponseTime
      timeRangeResult.data.maxAgentWaitTime = timeRangeResult.data.maxAgentWaitTime > 359999 ? 359999 : timeRangeResult.data.maxAgentWaitTime
      
      if (this.transcriptSearchFiltersComponent) {
        this.transcriptSearchFiltersComponent.handOffsFilter.fromValue = timeRangeResult.data.minTransferCount;
        this.transcriptSearchFiltersComponent.handOffsFilter.toValue = timeRangeResult.data.maxTransferCount;
        this.transcriptSearchFiltersComponent.responseTimeFilter.fromValue = {};
        this.transcriptSearchFiltersComponent.responseTimeFilter.toValue = {};
        this.transcriptSearchFiltersComponent.handlingTimeFilter.fromValue = {};
        this.transcriptSearchFiltersComponent.handlingTimeFilter.toValue = {};
        this.transcriptSearchFiltersComponent.milliSecondToTimeFormat(this.transcriptSearchFiltersComponent.handlingTimeFilter.fromValue, timeRangeResult.data.minHandlingTime);
        this.transcriptSearchFiltersComponent.milliSecondToTimeFormat(this.transcriptSearchFiltersComponent.handlingTimeFilter.toValue, timeRangeResult.data.maxHandlingTime);

        this.transcriptSearchFiltersComponent.agentHandlingTimeFilter.fromValue = {};
        this.transcriptSearchFiltersComponent.agentHandlingTimeFilter.toValue = {};
        this.transcriptSearchFiltersComponent.agentResponseTimeFilter.fromValue = {};
        this.transcriptSearchFiltersComponent.agentResponseTimeFilter.toValue = {};
        this.transcriptSearchFiltersComponent.agentWaitTimeFilter.fromValue = {};
        this.transcriptSearchFiltersComponent.agentWaitTimeFilter.toValue = {};
        this.transcriptSearchFiltersComponent.milliSecondToTimeFormat(this.transcriptSearchFiltersComponent.agentHandlingTimeFilter.fromValue, timeRangeResult.data.minAgentHandlingTime);
        this.transcriptSearchFiltersComponent.milliSecondToTimeFormat(this.transcriptSearchFiltersComponent.agentHandlingTimeFilter.toValue, timeRangeResult.data.maxAgentHandlingTime);
        this.transcriptSearchFiltersComponent.milliSecondToTimeFormat(this.transcriptSearchFiltersComponent.agentResponseTimeFilter.fromValue, timeRangeResult.data.minAgentResponseTime);
        this.transcriptSearchFiltersComponent.milliSecondToTimeFormat(this.transcriptSearchFiltersComponent.agentResponseTimeFilter.toValue, timeRangeResult.data.maxAgentResponseTime);
        this.transcriptSearchFiltersComponent.milliSecondToTimeFormat(this.transcriptSearchFiltersComponent.agentWaitTimeFilter.fromValue, timeRangeResult.data.minAgentWaitTime);
        this.transcriptSearchFiltersComponent.milliSecondToTimeFormat(this.transcriptSearchFiltersComponent.agentWaitTimeFilter.toValue, timeRangeResult.data.maxAgentWaitTime);

        this.transcriptSearchFiltersComponent.prepareFilters();
        this.transcriptSearchFiltersComponent.transcriptFilters['action'] = 'search';

        this.transcriptSearchFiltersComponent.localFilters.handlingTime = {
          updated: false,
          minHandlingTime: timeRangeResult.data.minHandlingTime,
          maxHandlingTime: timeRangeResult.data.maxHandlingTime
        }
        this.transcriptSearchFiltersComponent.localFilters.handOffs = {
          updated: false,
          minHandOffs: timeRangeResult.data.minTransferCount,
          maxHandOffs: timeRangeResult.data.maxTransferCount
        }
        this.transcriptSearchFiltersComponent.localFilters.agentHandlingTime = {
          updated: false,
          minAgentHandlingTime: timeRangeResult.data.minAgentHandlingTime,
          maxAgentHandlingTime: timeRangeResult.data.maxAgentHandlingTime
        }
        this.transcriptSearchFiltersComponent.localFilters.agentResponseTime = {
          updated: false,
          minAgentResponseTime: timeRangeResult.data.minAgentResponseTime,
          maxAgentResponseTime: timeRangeResult.data.maxAgentResponseTime
        }        
        this.transcriptSearchFiltersComponent.localFilters.agentWaitTime = {
          updated: false,
          minAgentWaitTime: timeRangeResult.data.minAgentWaitTime,
          maxAgentWaitTime: timeRangeResult.data.maxAgentWaitTime
        }

        this.transcriptSearchFiltersComponent.localFilters.handlingTime.minHandlingTimeDisplay = {};
        this.transcriptSearchFiltersComponent.localFilters.handlingTime.maxHandlingTimeDisplay = {};

        this.transcriptSearchFiltersComponent.localFilters.agentHandlingTime.minAgentHandlingTimeDisplay = {};
        this.transcriptSearchFiltersComponent.localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay = {};
        this.transcriptSearchFiltersComponent.localFilters.agentResponseTime.minAgentResponseTimeDisplay = {};
        this.transcriptSearchFiltersComponent.localFilters.agentResponseTime.maxAgentResponseTimeDisplay = {};
        this.transcriptSearchFiltersComponent.localFilters.agentWaitTime.minAgentWaitTimeDisplay = {};
        this.transcriptSearchFiltersComponent.localFilters.agentWaitTime.maxAgentWaitTimeDisplay = {};

        this.transcriptSearchFiltersComponent.milliSecondToTimeFormat(this.transcriptSearchFiltersComponent.localFilters.handlingTime.minHandlingTimeDisplay, timeRangeResult.data.minHandlingTime);
        this.transcriptSearchFiltersComponent.milliSecondToTimeFormat(this.transcriptSearchFiltersComponent.localFilters.handlingTime.maxHandlingTimeDisplay, timeRangeResult.data.maxHandlingTime);

        this.transcriptSearchFiltersComponent.milliSecondToTimeFormat(this.transcriptSearchFiltersComponent.localFilters.agentHandlingTime.minAgentHandlingTimeDisplay, timeRangeResult.data.minAgentHandlingTime);
        this.transcriptSearchFiltersComponent.milliSecondToTimeFormat(this.transcriptSearchFiltersComponent.localFilters.agentHandlingTime.maxAgentHandlingTimeDisplay, timeRangeResult.data.maxAgentHandlingTime);
        this.transcriptSearchFiltersComponent.milliSecondToTimeFormat(this.transcriptSearchFiltersComponent.localFilters.agentResponseTime.minAgentResponseTimeDisplay, timeRangeResult.data.minAgentResponseTime);
        this.transcriptSearchFiltersComponent.milliSecondToTimeFormat(this.transcriptSearchFiltersComponent.localFilters.agentResponseTime.maxAgentResponseTimeDisplay, timeRangeResult.data.maxAgentResponseTime);
        this.transcriptSearchFiltersComponent.milliSecondToTimeFormat(this.transcriptSearchFiltersComponent.localFilters.agentWaitTime.minAgentWaitTimeDisplay, timeRangeResult.data.minAgentWaitTime);
        this.transcriptSearchFiltersComponent.milliSecondToTimeFormat(this.transcriptSearchFiltersComponent.localFilters.agentWaitTime.maxAgentWaitTimeDisplay, timeRangeResult.data.maxAgentWaitTime);

        this.transcriptSearchFiltersComponent.localFilterMap.selectedContactReasons = JSON.parse(JSON.stringify(this.transcriptSearchFiltersComponent.selectedContactReasons));
        this.transcriptSearchFiltersComponent.localFilterMap.selectedResponseNames = JSON.parse(JSON.stringify(this.transcriptSearchFiltersComponent.selectedResponseNames));
        this.transcriptSearchFiltersComponent.localFilterMap.selectedRelatedTopics = JSON.parse(JSON.stringify(this.transcriptSearchFiltersComponent.selectedRelatedTopics));
        this.transcriptSearchFiltersComponent.localFilterMap.selectedIntentNames = JSON.parse(JSON.stringify(this.transcriptSearchFiltersComponent.selectedIntentNames));

        this.transcriptSearchFiltersComponent.localFilterMap.selectedContainment = this.transcriptSearchFiltersComponent.selectedContainment;
        this.transcriptSearchFiltersComponent.localFilterMap.selectedSentiment = this.transcriptSearchFiltersComponent.selectedSentiment;
        this.transcriptSearchFiltersComponent.localFilterMap.selectedBesSignals = this.transcriptSearchFiltersComponent.selectedBesSignals;
        this.transcriptSearchFiltersComponent.localFilterMap.selectedBasSignals = this.transcriptSearchFiltersComponent.selectedBasSignals;
        this.transcriptSearchFiltersComponent.localFilterMap.handlingTimeFilter = JSON.parse(JSON.stringify(this.transcriptSearchFiltersComponent.handlingTimeFilter));
        this.transcriptSearchFiltersComponent.localFilterMap.responseTimeFilter = JSON.parse(JSON.stringify(this.transcriptSearchFiltersComponent.responseTimeFilter));
        this.transcriptSearchFiltersComponent.localFilterMap.handOffsFilter = JSON.parse(JSON.stringify(this.transcriptSearchFiltersComponent.handOffsFilter));

        if (this.dataModel.filters.agentQueues.value.length === 0) {
          this.transcriptSearchFiltersComponent.localAgentQueues.isDisabled = false;
        }
        this.transcriptSearchFiltersComponent.localFilterMap.localAgentQueues = JSON.parse(JSON.stringify(this.transcriptSearchFiltersComponent.localAgentQueues));
        if (this.dataModel.filters.agentGroups.value.length === 0) {
          this.transcriptSearchFiltersComponent.localAgentGroups.isDisabled = false;
        }
        this.transcriptSearchFiltersComponent.localFilterMap.localAgentGroups = JSON.parse(JSON.stringify(this.transcriptSearchFiltersComponent.localAgentGroups));
        if (this.dataModel.filters.agentIds.value.length === 0) {
          this.transcriptSearchFiltersComponent.localAgentIds.isDisabled = false;
        }
        this.transcriptSearchFiltersComponent.localFilterMap.localAgentIds = JSON.parse(JSON.stringify(this.transcriptSearchFiltersComponent.localAgentIds));
        this.transcriptSearchFiltersComponent.defaultLocalFilterMap = JSON.parse(JSON.stringify(this.transcriptSearchFiltersComponent.localFilterMap));
        // this.resetTranscriptFilters();
      }
    },

    async loadMetricTopicConversations(pageNo = 1, payloadFields = {}, searchActivatedBy = null, mergedTopics = []) {
      this.controller.transcriptLoading = true;
      this.pageNo = pageNo;
      this.transcriptList = [];

      const metricSignals = this.controller.getListOfCheckedOptions();
      const searchKeyword = this.controller.searchText;
      const searchType = this.controller.searchType;
      let advancedFilterPayload
      if (!this.controller.checkAdvancedFilterIsEmpty()) {
        advancedFilterPayload = this.controller.getAdvancedFilterPayload();
      }

      let tabName = this.controller.activeSubPage;
      let fetchSavedTranscripts = false;
      if (tabName && tabName === 'experience') {
        tabName = 'besTab'
        fetchSavedTranscripts = Boolean(this.controller.savedTranscriptResultBes);
      }
      if (tabName && tabName === 'automation') {
        tabName = 'basTab'
        fetchSavedTranscripts = Boolean(this.controller.savedTranscriptResultBas);
      }

      let textQuery;
      const searchByTranscripts = searchKeyword && searchType == '1'
      const searchByConversationId = searchKeyword && searchType == '2'

      if (searchByConversationId) {
        textQuery = searchKeyword && searchKeyword.includes(",") ? searchKeyword.split(",") : [searchKeyword]
      } else if (searchByTranscripts) {
        textQuery = searchKeyword
      }

      const options = {
        from: this.from,
        topics: mergedTopics, 
        pageNo: this.pageNo,
        pageSize: this.pageSize + 1,
        sortBy: this.sortBy,
        contactReason: this.contactReason,
        topicDisplayNames: [this.contactReason],
        savedTranscripts: fetchSavedTranscripts,
        searchBy: searchType,
        ...(advancedFilterPayload && { advancedFilterPayload }),
        textQuery: textQuery,
        tabName: tabName,
        searchActivatedBy: searchActivatedBy
      };

      // add dropdown options
      if (metricSignals.length) {
        metricSignals.map((signal) => { options[signal] = true });
      }

      // add payloadFields (e.g. pageChanged())
      if (Object.keys(payloadFields).length) {
        Object.keys(payloadFields).map((key) => {
          options[key] = payloadFields[key];
        });
      }

      // add searchKeyword
      if (searchKeyword && searchKeyword !== '') {
        options.searchKeyword = searchKeyword;
      }

      const results = await this.fetchMetricTranscriptSearch(options);
      const success = results && results.status === 200;

      if (success) {
        const transcriptsExist = results.data && results.data.transcriptSearchResults && results.data.transcriptSearchResults.length;

        if (transcriptsExist) {
          if (results.data.transcriptSearchResults.length > this.pageSize) {
            this.transcriptList = results.data.transcriptSearchResults.slice(0, results.data.transcriptSearchResults.length - 1);
            this.highLightKeywords();
            this.pageItemStart = (this.pageNo - 1) * this.pageSize + 1;
            this.pageItemEnd = this.pageItemStart + this.pageSize - 1;
            this.pageCount = this.pageNo + 1;
          } else {
            this.transcriptList = results.data.transcriptSearchResults;
            this.highLightKeywords();
            this.pageItemStart = (this.pageNo - 1) * this.pageSize + 1;
            this.pageItemEnd = this.pageItemStart + results.data.transcriptSearchResults.length - 1;
            this.pageCount = this.pageNo;
          }
        } else {
          this.transcriptList = [];
          this.pageNo = 1;
          this.pageItemStart = 0;
          this.pageItemEnd = 0;
          this.pageCount = 0;
        }

        if (results && results.data && this.pageNo == 1) {
          // TODO: remove the following this.totalConversations after we fully migrated
          if(results.data.totalConversations != undefined && results.data.totalConversations != null) {
            this.totalConversations = results.data.totalConversations;
          }
          if (results.data.totalMatchedConversations) {
            this.totalMatchedConversations = results.data.totalMatchedConversations;
          } else {
            this.totalMatchedConversations = 0;
          }
        }
      }
      this.controller.transcriptLoading = false;
    },


    async loadTopicConversations(pageNo = 1, isPageChange = false, searchActivatedBy = null) {
      this.pageNo = pageNo;
      this.controller.loading = true;
      this.transcriptList = [];
      this.controller.transcriptSearchShowHeader = true;
      const mergedTopics = this.controller.parent && this.controller.parent.currentItem && this.controller.parent.currentItem.mergedTopics || []
      let options = {
        from: 'transcripts', 
        topics: mergedTopics,
        pageNo: this.pageNo, 
        pageSize: this.pageSize+1, 
        sortBy: this.sortBy, 
        contactReason: this.contactReason, 
        transcriptSearchFilter: this.transcriptSearchFiltersComponent.transcriptFilters,
        searchActivatedBy: searchActivatedBy
      }
      //call api to get transcript search result
      this.fetchTranscriptSearch(options).then((results)=>{
        if(results.data && results.data.transcriptSearchResults.length > 0) {
          if(results.data.transcriptSearchResults.length > this.pageSize) {
            this.transcriptList = results.data.transcriptSearchResults.slice(0, results.data.transcriptSearchResults.length-1);
            this.highLightKeywords();
            this.pageItemStart = (this.pageNo-1)*this.pageSize+1;
            this.pageItemEnd = this.pageItemStart + this.pageSize - 1;
            this.pageCount = this.pageNo+1;
          }
          else {
            this.transcriptList = results.data.transcriptSearchResults;
            this.highLightKeywords();
            this.pageItemStart = (this.pageNo-1)*this.pageSize+1;
            this.pageItemEnd = this.pageItemStart + results.data.transcriptSearchResults.length - 1;
            this.pageCount = this.pageNo;
          }  
        }
        else {
          this.transcriptList = [];
          this.pageNo = 1;
          this.pageItemStart = 0;
          this.pageItemEnd = 0;
          this.pageCount = 0;
        }
        if(results.data && this.pageNo == 1){
          // TODO: remove the following this.totalConversations after we fully migrated
          if(results.data.totalConversations != undefined && results.data.totalConversations != null) {
            this.totalConversations = results.data.totalConversations;
          }
          if(results.data.totalMatchedConversations) {
            this.totalMatchedConversations = results.data.totalMatchedConversations;
          }
          else {
            this.totalMatchedConversations = 0;
          }
        }
        this.controller.loading = false;
        if(this.transcriptList && this.transcriptList.length == 0) {
          this.controller.hasNoData = true;
        }
        else {
          this.controller.hasNoData = false;
        }
      })
      // call api to get topic display name list
      const isContactReasonDetailPage = this.controller.$refs.transcriptSearchFilters.contactReason
      if(!isPageChange) {
        this.loadListFilters(options, isContactReasonDetailPage)
      } 
    },

    async loadListFilters(options, isContactReasonDetailPage) {
      this.controller.$refs.transcriptSearchFilters.topicFilterLoading = true;

      this.transcriptSearchFiltersComponent.responseNameList = [];
      this.transcriptSearchFiltersComponent.relatedTopicList = [];
      this.transcriptSearchFiltersComponent.intentNameList = [];

      const fetchTopicDisplayNameListPromise = isContactReasonDetailPage ? Promise.resolve() : this.fetchTopicDisplayNameList(options);

      try {
        const [
          contactReasonsList, 
          responseNameList, 
          relatedTopicList, 
          intentNameList
        ] = await Promise.all([
          fetchTopicDisplayNameListPromise,
          this.fetchTopicResponseNameList(options),
          this.fetchRelatedTopicList(options),
          this.fetchIntentNames(options)
        ]);

        if (!isContactReasonDetailPage && contactReasonsList && contactReasonsList.data && contactReasonsList.data.length > 0) {
          this.transcriptSearchFiltersComponent.contactReasonsList = contactReasonsList.data;
          this.controller.$refs.transcriptSearchFilters.contactReasonsList = contactReasonsList.data;
        }

        if (responseNameList && responseNameList.data && responseNameList.data.length > 0) {
          this.transcriptSearchFiltersComponent.responseNameList = responseNameList.data;
          this.controller.$refs.transcriptSearchFilters.responseNameList = responseNameList.data;
        }

        if (relatedTopicList && relatedTopicList.data && relatedTopicList.data.length > 0) {
          this.transcriptSearchFiltersComponent.relatedTopicList = relatedTopicList.data;
          this.controller.$refs.transcriptSearchFilters.relatedTopicList = relatedTopicList.data;
        }

        if (intentNameList && intentNameList.data && intentNameList.data.length > 0) {
          this.transcriptSearchFiltersComponent.intentNameList = intentNameList.data;
          this.controller.$refs.transcriptSearchFilters.intentNameList = intentNameList.data;
        }

        this.controller.$refs.transcriptSearchFilters.topicFilterLoading = false;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },


    highLightKeywords() {
      this.transcriptList.forEach(transcript => {
        transcript.messages.forEach(message => {
          if (message.text) {
            message.text = message.text.replace(/<span class='highlight-keywords'>|<\/span>/g, "")
          }
        })
      });

      let operatorsEnum;
      let payload;

      if (this.isMetricAnalysisPanel) {
        payload = this.controller.advancedFilterPayload;
        operatorsEnum = this.controller.operatorsEnum;
      } else {
        // transcript search page + detailed transcrib tab
        payload = this.transcriptSearchFiltersComponent.advancedFilterPayload;
        operatorsEnum = this.transcriptSearchFiltersComponent.operatorsEnum;
      }

      // if any conditions exist, we deleted the keyword
      for (const groupName in payload) {
        let group = payload[groupName];
        if (groupName === 'groupOperators') continue;

        if (group && (operatorsEnum.find(en => en.key == group.operator).label === 'NOT AND' || operatorsEnum.find(en => en.key == group.operator).label === 'NOT OR')) continue;
        if (group && group === 'groupB' && (operatorsEnum.find(en => en.key == payload.groupOperators.groupBOperator).label === 'NOT AND' || operatorsEnum.find(en => en.key == payload.groupOperators.groupBOperator).label === 'NOT OR')) continue;
        if (group && group === 'groupC' && (operatorsEnum.find(en => en.key == payload.groupOperators.groupBOperator).label === 'NOT AND' || operatorsEnum.find(en => en.key == payload.groupOperators.groupBOperator).label === 'NOT OR')) continue;

        if (group && group.conditions) {
          if(group.operator == "1") {
            for (const transcript of this.transcriptList) {
              let conditionsMatchedCount = 0; // we have this counter so that the transcript is highlighted only if all conditions are matched
              
              for (const condition of group.conditions) {
                const conditionValue = condition.value != null && condition.value != '' ? condition.value.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : null;

                for (const message of transcript.messages) {
                  const cleanedMessage = this.returnCleanedMessage(message);

                  if (this.isConditionExactMatch(condition, message, { regexVal: conditionValue, testVal: cleanedMessage})) {
                    conditionsMatchedCount++;
                    break;
                  } else if (this.isConditionContainsMatch(condition, message, { regexVal: conditionValue, testVal: cleanedMessage})) {
                    conditionsMatchedCount++;
                    break;
                  }
                }
              }

              const allConditionsFound = conditionsMatchedCount == group.conditions.length;

              if(allConditionsFound) { 
                for (const condition of group.conditions) {
                  for (let message of transcript.messages) {

                    const alreadyContainsHighlight = message.text.includes('<span class=\'highlight-keywords\'>');
                    
                    if (alreadyContainsHighlight) {
                      const tempHighlitedMessage = JSON.parse(JSON.stringify(message.text));
                      // temporarily remove highlight for contains case
                      // due to this.returnCleanedMessage(message) in elseIf statement modifying the message object

                      if (this.isConditionExactMatch(condition, message, { regexVal: condition.value, testVal: message.text })) {
                        message.text = this.handleHighlightForExactMatch(condition, message);

                      } else if (this.isConditionContainsMatch(condition, message, { regexVal: condition.value, testVal: this.returnCleanedMessage(message) })) {
                        message.text = this.handleHighlightForContainsMatch(condition, message);

                      } else  {
                        message.text = tempHighlitedMessage;
                      }

                    } else {
                      // does not contain highlight
                      if (this.isConditionExactMatch(condition, message)) {
                        message.text = this.handleHighlightForExactMatch(condition, message);
                      } else if (this.isConditionContainsMatch(condition, message)) {
                        message.text = this.handleHighlightForContainsMatch(condition, message);
                      }

                    }
                  }
                }
              }
            }
          } else {
          // do highlight for OR case
            for (const transcript of this.transcriptList) {
              for (const condition of group.conditions) {
                for (const message of transcript.messages) {
                  if (this.isConditionExactMatch(condition, message)) {
                    message.text = this.handleHighlightForExactMatch(condition, message);
                  } else if (this.isConditionContainsMatch(condition, message)) {
                    message.text = this.handleHighlightForContainsMatch(condition, message);
                  }
                }
              }
            }
          }
        }
      }
    },

    isConditionExactMatch(condition, message, regexConditions) {
      if (regexConditions) {
        const { regexVal, testVal } = regexConditions;
        return condition.searchType == '1' && condition.messageType.includes(message.sentBy) && (new RegExp(`(?<!\\w)${regexVal}(?!\\w)`, 'gi')).test(testVal)
      }

      return condition.searchType == '1' && condition.messageType.includes(message.sentBy)
    },

    isConditionContainsMatch(condition, message, regexConditions) {
      if (regexConditions) {
        const { regexVal, testVal } = regexConditions;
        return condition.searchType == '2' && condition.messageType.includes(message.sentBy) && (new RegExp(`${regexVal}`, 'gi')).test(testVal)
      }
      return condition.searchType == '2' && condition.messageType.includes(message.sentBy)
    },

    handleHighlightForExactMatch(condition, message) {
      return message.text.replace(new RegExp(`(?<!\\w)${condition.value}(?!\\w)`, 'gi'), `<span class='highlight-keywords'>$&</span>`)
    },

    handleHighlightForContainsMatch(condition, message) {
      return message.text.replace(new RegExp(`${condition.value}`, 'gi'), `<span class='highlight-keywords'>$&</span>`)
    },

    returnCleanedMessage(message) {
      return message.text.replace(/<span class='highlight-keywords'>|<\/span>/g, "")
    },


    resetTranscriptFilters() {
      this.transcriptSearchFiltersComponent.transcriptFilters["action"] = "search";
      this.transcriptSearchFiltersComponent.transcriptFilters["savedTranscripts"] = false;
      this.transcriptSearchFiltersComponent.transcriptFilters["sortBy"] = "newToOld";
      delete this.transcriptSearchFiltersComponent.transcriptFilters["sentiment"];
      delete this.transcriptSearchFiltersComponent.transcriptFilters["topicDisplayNames"];
      delete this.transcriptSearchFiltersComponent.transcriptFilters["responseNames"];
      delete this.transcriptSearchFiltersComponent.transcriptFilters["relatedTopics"];

      delete this.transcriptSearchFiltersComponent.transcriptFilters["conversationTypes"];
      delete this.transcriptSearchFiltersComponent.transcriptFilters["textQuery"];
      delete this.transcriptSearchFiltersComponent.transcriptFilters["searchKeyword"];

      this.transcriptSearchFiltersComponent.selectedContactReasons = [];
      this.transcriptSearchFiltersComponent.selectedResponseNames = [];
      this.transcriptSearchFiltersComponent.selectedRelatedTopics = [];
      this.transcriptSearchFiltersComponent.selectedIntentNames = [];
      this.transcriptSearchFiltersComponent.selectedContainment = [];
      this.transcriptSearchFiltersComponent.selectedSentiment = [];
      this.transcriptSearchFiltersComponent.selectedBesSignals = [];
      this.transcriptSearchFiltersComponent.selectedBasSignals = [];

      this.transcriptSearchFiltersComponent.localFilterMap.selectedContactReasons = [];
      this.transcriptSearchFiltersComponent.localFilterMap.selectedResponseNames = [];
      this.transcriptSearchFiltersComponent.localFilterMap.selectedRelatedTopics = [];
      this.transcriptSearchFiltersComponent.localFilterMap.selectedIntentNames = [];

      this.transcriptSearchFiltersComponent.localFilterMap.selectedSentiment = [];
      this.transcriptSearchFiltersComponent.localFilterMap.selectedBesSignals = [];
      this.transcriptSearchFiltersComponent.localFilterMap.selectedBasSignals = [];
      this.transcriptSearchFiltersComponent.localFilterMap.selectedContainment = [];
      this.transcriptSearchFiltersComponent.localFilterMap.localAgentQueues = [];
      this.transcriptSearchFiltersComponent.localFilterMap.localAgentGroups = [];
      this.transcriptSearchFiltersComponent.localFilterMap.localAgentIds = [];
      this.transcriptSearchFiltersComponent.appliedFilterCount = 0;
      this.transcriptSearchFiltersComponent.searchKeyword = '';
    },
    handleTranscriptClick(transcript) {
      this.selectedItem = transcript
      this.$emit('handle-transcript-click', true);
      // this.$store.dispatch('transcriptLog', {name: 'transcripts_clicked', data: {transcript: transcript}});
      this.$refs.pageModal.open();
    },
    handleViewTranscriptSummary(event) {
      if (this.controller && this.controller.hideTranscriptPopover) {
        this.controller.hideTranscriptPopover();
      }

      const transcriptIndex = this.transcriptList.findIndex(t => t.conversationId === event.conversationId)
      if (!this.transcriptList || transcriptIndex === -1) {
        return;
      }
      if (event.opened) {
        this.$set(this.transcriptList[transcriptIndex], 'isOpened', true)
      } else {
        this.$set(this.transcriptList[transcriptIndex], 'isOpened', false)
      }

      if (event.isError) {
        this.$set(this.transcriptList[transcriptIndex], 'isError', true)
      } else {
        this.$set(this.transcriptList[transcriptIndex], 'isError', false)
      }

      // Need to set the contentSummary when we open the summary from wy-analytics-search-expand.vue
      if (event.contentSummary) {
        this.$set(this.transcriptList[transcriptIndex], 'contentSummary', event.contentSummary)
      } else {
        this.$set(this.transcriptList[transcriptIndex], 'contentSummary', '')
      }
    },
    handlePageModalOpen() {
      this.transcriptExpanded = true;
      if (document.querySelector('.transcript-detail-export-btn')) {
        document.querySelector('.transcript-detail-export-btn').style.display = "none";
      }
      // this.$store.dispatch('transcriptLogWithFilters', {name: 'transcript_time_spent', data: {time_spent: WyUtils.getTimeDiff(this.initDate)}});
    },

    handlePageModalClose() {
      this.transcriptExpanded = false;
      if (document.querySelector('.transcript-detail-export-btn')) {
        document.querySelector('.transcript-detail-export-btn').style.display = "inline-flex";
      }

      if (!this.initDate) {
        this.initDate = new Date();
        this.$emit('handle-transcript-click', false);
      }
      this.$emit('handle-transcript-click', false);

    },

    refreshPage() {
      this.refreshTableData();
    },

    handleCloseModeal() {
      if (this.$refs.pageModal) {
        this.$refs.pageModal.close();
      }
    }
  },

  mounted() {
    this.transcriptSearchFiltersComponent = this.controller.$refs.transcriptSearchFilters;

    if (document.querySelector(".wy-analytics-contact-reasons-detail")) {
      document.querySelector(".wy-analytics-contact-reasons-detail").addEventListener('click', this.handleCloseModeal);
    }
  },

  async created() {
    this.initDate = new Date();

    if (!this.isHideResponse) {
      this.sortByList.push({ key: 'longestResponseTime', label: 'Longest agent response time' });
      this.sortByList.push({ key: 'shortestResponseTime', label: 'Shortest agent response time' });
    }

    this.sortBy = 'newToOld';
  },

  beforeDestroy() {
    if (document.querySelector(".wy-analytics-contact-reasons-detail")) {
      document.querySelector(".wy-analytics-contact-reasons-detail").removeEventListener('click', () => this.handleCloseModeal);
    }
  }
});
</script>

<style lang="scss">
.transcript-filter-dropdown {
  .el-select-dropdown__list {
    padding: 5px !important;

    .el-select-dropdown__item {
      color: var(--site-font-tertiary-color) !important;
      font-weight: 400;
      font-size: 14.22px;
      border-radius: 4px;
      padding: 0 8px;
    }

    .el-select-dropdown__item.selected {
      color: var(--site-font-tertiary-color) !important;
      font-weight: 400 !important;
      background: #E8F1FF;
    }
  }

  .el-select-dropdown__wrap.el-scrollbar__wrap {
    display: block !important;
  }
}

.wy-analytics-transcript-search-results {
  position: relative;
  padding-right: 0px;
  // margin-bottom: 48px;
  min-height: 359px;
  margin-top: 15px;

  .no-transcript-found {
    text-align: center;
    display: block;
    border: none;
    height: 155px;
    // width: 100%;
    margin-top: 10%;
    background-position-x: 50%;
    background-repeat: no-repeat;
    // background-size: 36%;
    background-image: url('../../assets/icons/icon_no_data_new.svg');
  }

  .no-data-title {
    width: 100%;
    margin-top: 20px;
    text-align: center;
    font-size: 20px;
    color: var(--site-font-primary-color) !important;
    font-weight: 600;
  }

  .no-data-subtitle {
    width: 100%;
    margin-top: 20px;
    text-align: center;
    // font-size: 20px;
    color: var(--site-font-primary-color) !important;
  }

  .search-result-content {
    .div-transcripts-viewer-header {
      display: inline-flex;
      width: 100%;
      margin: 0 0 -6px 0;
      // min-width: 1075px;

      .div-transcript-page-infor {
        float: left;
        padding-left: 0;
        padding-top: 0px;
        padding-bottom: 3px;
        font-size: 14px;
        line-height: 28px;
        font-weight: 500;
        color: var(--site-font-tertiary-color);
        margin-bottom: 0px;
        margin-top: 6px;
      }

      .div-transcript-pagination {
        float: right;
        padding-right: 0px;
        // padding-top: 9px;
        height: 20px;

        .el-pagination {
          padding-right: 0px;
          display: flex;
        }

        .el-pagination button {
          //color: #002852;
          min-width: 26px !important;
          color: #606060;
          font-weight: bold;
          padding-right: 0px;
          margin-left: 20px;
        }

        .btn-prev {
          width: 34px;
          height: 34px;
          border-top-left-radius: 5px;
          border-bottom-left-radius: 5px;
          border: 1px solid #CAD2DA;
          display: flex;
          align-items: center;
          background-size: 20%;
          // background-position-x: 2px;
          // background-position-y: -5px;
          background-image: url('../../assets/icons/icon_pagenation_prev.svg');
          background-repeat: no-repeat;

          &:hover {
            background-color: #F4F6F8;
          }
        }

        .btn-prev .el-icon,
        .btn-next .el-icon {
          display: none;
        }

        .btn-next {
          width: 34px;
          height: 34px;
          border-top-right-radius: 5px;
          border-bottom-right-radius: 5px;
          border: 1px solid #CAD2DA;
          display: flex;
          align-items: center;
          background-size: 20%;
          // background-position-x: 2px;
          // background-position-y: -5px;
          background-image: url('../../assets/icons/icon_pagenation_next.svg');
          background-repeat: no-repeat;

          &:hover {
            background-color: #F4F6F8;
          }
        }

        .el-pagination button.btn-prev:disabled {
          background-image: url('../../assets/icons/icon_page_prev_disable.svg');
        }

        .el-pagination button.btn-next:disabled {
          background-image: url('../../assets/icons/icon_page_next_disable.svg');
        }

        .el-pagination span:not([class*=suffix]) {
          word-spacing: 7px;
          width: 34px;
          height: 34px;
          border-radius: 5px;
          border: 1px solid #CAD2DA;
        }
      }

      .sort-by-text-container {
        margin-left: auto;
        font-size: 14.22px;
        color: #828E9A;
        font-weight: 500;
        height: 46px;

        .el-select .el-input .el-select__caret {
          color: #606060 !important;
        }
      }

      .short-name-transcript-filter {
        margin-right: 5px;
        padding-top: 6px;
        height: 20px;
        margin-left: 0px !important;

        input.el-input__inner {
          border-width: 0px 0px 0px 0px !important;
          color: var(--site-font-tertiary-color);
          padding-left: 0px !important;
          font-weight: bold !important;
          background: transparent;
          width: 99px; // fit-content doesn't work well for some reason after bolding the text
          text-align: right;

          &::placeholder {
            color: #002852;
          }
        }
      }

      .transcript-filter {
        margin-right: 5px;
        padding-top: 13px;
        height: 20px;
        margin-left: 0px !important;

        input.el-input__inner {
          border-width: 0px 0px 0px 0px !important;
          color: var(--site-font-tertiary-color);
          font-weight: bold !important;
          padding-left: 0px !important;
          width: 200px !important;
          text-align: right;

          &::placeholder {
            color: #002852;
          }
        }

        .el-input .el-select__caret {
          // color: #002852;
          // font-weight: bold;
          color: #606060;
        }

        .el-icon-arrow-up:before {
          content: "\e6e1";
        }

        .el-input--mini {
          font-size: 12px;
          height: unset;
          width: unset;
          padding-left: unset;
          padding-bottom: unset;
        }

        input.el-input__inner {
          height: 23px;
          padding-left: 0px;
          line-height: 24px;
          display: inline-flex;
          color: var(--site-font-tertiary-color);
          // font-weight: 500 !important;
          // font-size: 14.22px;
          align-items: center;
        }

        .el-input--mini .el-input__icon {
          line-height: 24px;
        }
      }
    }

    .div-transcripts-viewer-header .el-input {
      border: 0px solid rgb(153, 152, 152);
    }

    .div-transcripts-viewer-content {
      // display: inline-flex;
      // height: calc(100vh - 356px);
      display: block;
      width: 100%;
      height: calc(100vh - 333px);
      // height: calc(100vh - 305px);
      /* -webkit-column-count: 4; */
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 20px;
      grid-auto-rows: minmax(100px, auto);

      width: 100%;

      .el-table__body-wrapper {
        overflow-x: hidden;
        overflow-y: auto;
        height: 240px;
      }

      .div-transcript-details {
        border: 0.5px solid var(--unnamed-color-cbcbcb);
        background: #FFFFFF 0% 0% no-repeat padding-box;
        border: 0.5px solid #E8E8E8;
        border-radius: 10px;
        height: calc(100% - 45px);
        min-width: 308px;
        -webkit-column-break-inside: avoid;
        vertical-align: top;
        display: inline-block;
        overflow: hidden;
        border: 1px solid #CAD2DA;
        box-shadow: 0px 2px 1px rgba(0, 0, 0, 0.05), 0px 0px 1px rgba(0, 0, 0, 0.25);
        border-radius: 5px;

        .wy-analytics-transcript-search-details {
          height: 100%;
        }
      }

      .div-transcript-details:nth-child(4n) {
        margin-right: 0px !important;
      }
    }

    .el-input.is-disabled {
      .el-select__caret {
        color: #C0C4CC !important;
      }

      .el-input__inner {
        background-color: #FFF;
        border-color: #E4E7ED;
        color: #C0C4CC !important;
        cursor: not-allowed;
      }
    }

    .no-saved-content {
      color: var(--site-font-primary-color);
      background-color: transparent;
      margin-bottom: 3px;
      height: calc(100vh - 495px);

      .no-data {
        text-align: center;
        display: block;
        border: none;
        height: 220px;
        margin-top: 138px;
        background-position-x: 50%;
        background-repeat: no-repeat;
        background-size: 300px;
        background-image: url('../../assets/images/analytics/empty_saved_transcript.svg');
      }

      .no-data-content {
        width: 100%;
        margin-top: 0px;
        text-align: center;
        color: var(--site-font-secondary-color) !important;

        .no-data-title {
          font-size: 20px;
          font-weight: 600;
        }

        .no-data-subtitle {
          margin-top: 24px;
          font-size: 14px;
          color: var(--site-font-secondary-color) !important;
          font-weight: 400;
        }
      }

      .no-data-content-first-row {
        width: 100%;
        text-align: center;
        color: var(--site-font-primary-color) !important;
        padding-top: 16px;
        font-size: 14px;
        font-weight: 500;
      }

      .no-data-content-second-row {
        width: 100%;
        text-align: center;
        color: var(--site-font-primary-color) !important;
        font-size: 14px;
        font-weight: 500;
      }
    }
  }

  .dropdown {
    min-width: 1190px;
  }

  .dropdown.el-dropdown {
    height: 35px;
    min-width: unset;
  }

  ul.el-pager {
    display: none;
  }

  input.el-input__inner {
    border: 0px;
  }

  .input__inner:focus {
    border: 0px;
  }

  .el-select-dropdown__item.selected {
    color: #000;
    font-weight: 700;
  }
}
</style>